import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Big page title block rendered at the top of each screen's content. */
export function PageHeader({
  title,
  subtitle,
  legend,
  actions,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  legend?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col gap-3 md:flex-row md:items-start md:justify-between', className)}>
      <div className="min-w-0">
        <h1 className="text-2xl font-bold tracking-tight text-ink-strong">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-ink-muted">{subtitle}</p>}
      </div>
      <div className="flex shrink-0 items-center gap-3">
        {legend && <div className="flex flex-wrap items-center gap-3">{legend}</div>}
        {actions}
      </div>
    </div>
  );
}
